//liuxu
//热点追踪
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node, CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // 浏览器全局变量(root 即 window)
        root.computationTime = factory(root.jQuery);
    }
}(this, function ($) {
  var hotTrace = {
    buildHotTrace: function (data) {
        var T = this,
            hotHtml = "";
        if (data && data.length) {
            for(var i=0; i < data.length && i < 5; i++){
                var hideClass = '';
                if(i > 0){
                  hideClass = ' hide';
                }
                var item = data[i];
                hotHtml += '<div class="chinaso_rdzz_tab_con'+ hideClass +'">' + 
                            '<h2 class="chinaso_rdzz_title">' + 
                              '<a href="/newssearch/all/allResults?q=' + item.event_name + '" target="_blank">' + item.event_name + '</a>' +
                              '<a href="/newssearch/all/allResults?q=' + item.event_name + '" class="more">更多>></a>' +
                            '</h2>' + 
                            '<div class="chinaso_rdzz_tab_list">' +
                              '<div class="icon-time"></div>' +
                              '<div class="time-list scrollDiv">' +
                                '<ul class="scrollUl">';
                for(var j=0; j < item.list.length && j < 3; j++) {
                  var itemList = item.list[j];
                  hotHtml += '<li>' + 
                              '<em></em>' + 
                              '<span class="time">' + T.dateDiff(itemList.pubtime) + '</span>' + 
                              '<a href="'+ itemList.url +'" target="_blank" class="clearb">';
                  if (itemList.image_url && itemList.image_url.length && itemList.image_url[0] !=''){
                    hotHtml += '<div class="img-box chinaso_rdzz_ico">';
                    if (itemList.video_url){
                      hotHtml += '<i></i>';
                    }
                    hotHtml +=   '<img src="' + itemList.image_url[0] + '-104-65.jpg"></div>'; 
                  }            
                  hotHtml += '<h2>';
                  if(itemList.source_type=="微博") {
                    hotHtml += '<img class="weibo_icon" src="../static/v4/image/weibo_icon.png">';
                  }
                  hotHtml += itemList.title;
                  if(itemList.video_url && !itemList.image_url[0]) {
                    hotHtml += '<img class="video_icon" src="../static/v4/image/video_icon.png">';
                  }
                  hotHtml += '</h2><p>';
                  if (itemList.weibo_icon) {
                    hotHtml += '<img src="' + itemList.weibo_icon + '">';
                  }
                  if (itemList.source) {
                    hotHtml += '<span class="span_source">' + itemList.source +'</span>';
                  }
                  hotHtml += '</p></a></li>';
                }
                hotHtml += '</ul><div class="track"><div></div></div></div></div></div>';
            }
        }
        return hotHtml;
    },
    hotTraceNum: function (num) {
      var numHtml = ''
      if(num) { 
        for(var i=0; i < num && i < 5; i++) {
          var curClass = '',
              n = i+1;
          if(i == 0) {
            curClass = ' class="cur"';
          }
          numHtml += '<li' + curClass + '><a href="javascript:void(0);">'+ n +'</a></li>';
        }
      }
      return numHtml;
    },
    dateDiff: function (time, type) {
      // 补全为13位
      var arrTimestamp = String(time).split('');
      for (var start = 0; start < 13; start++) {
        if (!arrTimestamp[start]) {
          arrTimestamp[start] = '0';
        }
      }
      var timestamp = arrTimestamp.join('') * 1;
    
      var minute = 1000 * 60;
      var hour = minute * 60;
      var day = hour * 24;
      var halfamonth = day * 15;
      var month = day * 30;
      var now = new Date().getTime();
      var diffValue = now - timestamp;
    
      // 如果本地时间反而小于变量时间
      if (diffValue < 0) {
        return '刚刚';
      }
    
      // 计算差异时间的量级
      var monthC = diffValue / month;
      var weekC = diffValue / (7 * day);
      var dayC = diffValue / day;
      var hourC = diffValue / hour;
      var minC = diffValue / minute;
    
      // 数值补0方法
      var zero = function(value) {
        if (value < 10) {
          return '0'+ value;
        }
        return value;
      };
      // 使用
      if (monthC > 12) {
        // 超过1年，直接显示年月日
        return (function() {
          var date = new Date(timestamp);
          return date.getFullYear()+'年'+ zero(date.getMonth() + 1)+'月'+zero(date.getDate())+'日';
        })();
      }
      // if (monthC >= 1) {
      //   return parseInt(monthC)+'月前';
      // }
      if (dayC >= 1) {
        return (function() {
          var date = new Date(timestamp);
          return zero(date.getMonth() + 1)+'月'+zero(date.getDate())+'日';
        })();
      }
      // if (dayC >= 1 && dayC < 10) {
      //   return parseInt(dayC)+ '天前';
      // }
      if (hourC >= 1) {
        return parseInt(hourC)+'小时前';
      }
      if (minC > 10) {
        return parseInt(minC)+'分钟前';
      }
      return '刚刚';
    },
    autoPlay: function(){
      var T = this;
      T.timer = setInterval(function(){  //打开定时器
        T.iNow = T.iNow + 1;       //让图片的索引值次序加1，这样就可以实现顺序轮播图片
        if(T.iNow>$(".chinaso_rdzz_tab_con").length-1){ //当到达最后一张图的时候，让iNow赋值为第一张图的索引值，轮播效果跳转到第一张图重新开始
          T.iNow=0;
        }
        // $('.chinaso_rdzz_tab li').eq(T.iNow).trigger("click"); //模拟触发数字按钮的click
        $('.chinaso_rdzz_tab li').eq(T.iNow).addClass('cur').siblings().removeClass('cur');
        $('.chinaso_rdzz_tab_con').hide().eq(T.iNow).show();
        $(".scrollDiv").scrollbar({contentCls:"scrollUl"});
      },3000); //3000为轮播的时间
    },
    stopPlay: function(){
      var T = this;
      clearInterval(T.timer);
    },
    init: function () {
        var T = this;
        T.timer = null;
        T.iNow = 0;
        //请求数据
        $.ajax({
            type: 'GET',
            url: '/v5/general/v1/web/search/hottrace',
            dataType: 'json',
            contentType: "application/x-www-form-urlencoded;charset=UTF-8",
            timeout: 30000,
            success: function (data) {
                $('#chinaso_rdzz_con').html(T.buildHotTrace(data.data));
                $('.chinaso_rdzz_tab ul').html(T.hotTraceNum(data.data.length));
                $(".scrollDiv").scrollbar({contentCls:"scrollUl"});
            },
            error: function (xhr, type) {
              
            }
        });
        //热点追踪切换
        $('.chinaso_rdzz_tab').on('click', 'li', function () {
          var index = $(this).index();
          T.iNow = index;
          $(this).addClass('cur').siblings().removeClass('cur');
          $('.chinaso_rdzz_tab_con').hide().eq(index).show();
          $(".scrollDiv").scrollbar({contentCls:"scrollUl"});
        });
        //鼠标悬浮停止自动切换
        $("#chinaso_rdzz_con").hover(function(){T.stopPlay()}, function(){T.autoPlay()});
    }
  }
  return hotTrace;
}))



//////////////////
// WEBPACK FOOTER
// ./static/v4/js/hotTrace.js
// module id = 6ba12bfd58370dc6b7f2
// module chunks = 1